// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3eJV6","title":"Info_title__1goOQ","selects":"Info_selects__2Ewi0","requiredAsterisk":"Info_requiredAsterisk__gaNFC"};